import dayjs from "dayjs";
import i18n from "@/i18n/index";
import type { ManipulateType } from "dayjs";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

// Extend jsPDF with autoTable
(jsPDF as any).API.autoTable = autoTable;

import { ref } from "vue";
import { useAuthenticatedFetch } from "../../auth/useAuthenticatedFetch";
import { packs, subscriptions, clubUUID, currentClub } from "@/shared/state";
import { useGlobal } from "@/composables/global/useGlobal";
import { setDefaultImage, getImageUrl } from "@/utils/global";
import { generateArticles } from "@/config/contract/defaultArticles";
import { contractsRegistry } from "@/config/contractsRegistry";

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useContrat() {
  const { formatDate, formatDaysToPeriod } = useGlobal();

  const error = ref<string | null>(null);

  const contratPDF = async (
    member_info: any,
    active_subscription: any,
    { logoImageData, logoNaturalWidth, logoNaturalHeight }: any,
    { signatureImageData, signatureNaturalWidth, signatureNaturalHeight }: any,
    typeOfFile: string,
  ) => {
    // Create a new jsPDF instance
    const doc = new jsPDF();
    console.log("active_subscription");
    console.log(active_subscription);
    // Define personal info dynamically
    const memberInfo = {
      contractNumber: active_subscription?.contractNumber?.toString() ?? "",
      name: member_info?.name?.toString() ?? "",
      dateBirth: formatDate(member_info?.dateBirth) ?? "",
      adresse: member_info?.adresse?.toString() ?? "",
      tele: member_info?.tele?.toString() ?? "",
      email: member_info?.email?.toString() ?? "",
      occupation: member_info?.occupation?.toString() ?? "",
      cin: member_info?.cin?.toString() ?? "",
      gender: member_info?.gender ? "Homme" : "Femme",
    };

    let sellerInfo: any = null;
    let memberSubscription: Array<Array<string | number>> = [];
    /**details abonner (subscription adherent) */
    let PrixAassurance = "0.00 MAD";
    let totalAssurance = 0;
    if (active_subscription?.assurance) {
      totalAssurance = active_subscription?.assurance?.total_amount;
      PrixAassurance =
        active_subscription?.assurance?.total_amount?.toFixed(2) + " MAD";
    }
    /*else if (member_info?.active_assurance) {
      totalAssurance = 0;// member_info?.active_assurance?.total_amount;
      PrixAassurance =
        member_info?.active_assurance?.total_amount?.toFixed(2) + " MAD";
    }*/

    if (active_subscription) {
      sellerInfo = {
        name: active_subscription?.seller?.name ?? "",
        ce: ".............................................",
      };
      console.log(sellerInfo);
      const {
        promotion,
        pack,
        promo_price: base_promo_price,
        pack_price: base_pack_price,
        total_amount: totalAmountRaw,
        total_fees: totalFees = 0,
        discount_amount = 0,
        total_services_price = 0,
        start_date,
        end_date,
        subscription,
      } = active_subscription;

      // --- Prices ---
      const promo_price = base_promo_price ?? 0;
      const origin_pack_price = base_pack_price ?? 0;
      const promoted_price = promo_price ? origin_pack_price - promo_price : 0;

      // Real total amount after removing fees & assurance
      const total_amount = (totalAmountRaw ?? 0) - (totalFees + totalAssurance);

      // Discount includes real discount + promotion difference
      const total_discount = discount_amount + promoted_price;

      // --- Data array ---
      memberSubscription = [
        [
          subscription?.name ?? "",
          pack?.name?.toString() ?? "",
          formatDate(start_date),
          formatDate(end_date),
          `${origin_pack_price?.toFixed(2)} DH`,
          `${total_discount?.toFixed(2)} DH`,
          `${total_services_price ?? 0} DH`,
          `${total_amount?.toFixed(2)} DH`,
        ],
      ];
    }

    const memberServicesCredits: Array<[string, string, string, string]> = [];
    if (active_subscription?.member_activity_credits) {
      active_subscription?.member_activity_credits?.map((activity_credit) => {
        memberServicesCredits.push([
          activity_credit?.activity?.name ?? "",
          `${activity_credit?.price ?? "0.00"} DH`,
          activity_credit?.total_sessions?.toString() ?? "",
          activity_credit?.remaining.toString() ?? "",
        ]);
      });

      console.log("memberServicesCredits");
      console.log(memberServicesCredits);
    }
    const ListFrais: Array<[string, string]> = [];
    if (active_subscription?.fees) {
      active_subscription?.fees?.map((fee) => {
        ListFrais.push([
          fee?.fee?.name ?? "not found",
          fee?.price.toFixed(2) + " MAD",
        ]);
      });
    }
    if (active_subscription?.total_fees) {
      ListFrais.push([
        "Total Frais",
        active_subscription?.total_fees.toFixed(2) + " MAD",
      ]);
    }
    const ListTransactions: Array<[string, string, string]> = [];
    const TotalsByPaymentMethod: Record<string, number> = {};
    if (active_subscription?.transactions) {
      active_subscription?.transactions?.map((transaction) => {
        ListTransactions.push([
          transaction?.paymentMethod ?? "not found",
          formatDate(transaction?.paymentDate),
          transaction?.amount_paid.toFixed(2) + " MAD",
        ]);
        // Calculate totals by payment method
        const method = transaction?.paymentMethod ?? "not found";
        const amount = transaction?.amount_paid ?? 0;

        if (!TotalsByPaymentMethod[method]) {
          TotalsByPaymentMethod[method] = 0;
        }
        TotalsByPaymentMethod[method] += amount;
      });
    }
    console.log("currentClub.value.slug");
    console.log(currentClub.value.slug);
    const clubKey = currentClub.value.slug ?? "onefit";
    const generator =
      contractsRegistry[clubKey] || contractsRegistry["default"];
    const data = {
      member_info,
      ListFrais,
      memberSubscription,
      PrixAassurance,
      ListTransactions,
      TotalsByPaymentMethod,
      active_subscription,
      memberServicesCredits,
    };
    const { firstArticles, generalArticles } = generator(data);

    //const { firstArticles, generalArticles } = generateArticles(data);

    // Parameters for positioning

    const pageWidth = doc.internal.pageSize.getWidth(); // Full page width
    const pageHeight = doc.internal.pageSize.getHeight(); // Full page height
    let y = 10;
    let descriptionMarginBottom = 2;
    let descriptionLineHeight = 4;
    let titleMarginBottom = 4;
    const tableMarginBottom = 4;
    const lineHeight = 10;
    const leftX = 10;

    // Set the desired width and calculate height to maintain the aspect ratio
    const desiredWidth = 26;
    const aspectRatio = logoNaturalHeight / logoNaturalWidth; // Height / Width to maintain aspect ratio
    const desiredHeight = desiredWidth * aspectRatio;
    console.log("logoImageData");
    console.log(logoImageData);
    if (logoImageData) {
      doc.addImage(
        logoImageData,
        "JPEG",
        leftX - 5,
        y - 5,
        desiredWidth,
        desiredHeight,
      );
      y += 6;
    }

    function addPage() {
      if (y + lineHeight + 6 > pageHeight) {
        doc.addPage(); // Create a new page
        y = 10; // Reset y position
      }
    }

    // Helper function to add personal information
    function addMemberInfo() {
      y += 12;
      doc.setTextColor(0, 0, 0); // White text

      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`Nom`, leftX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(` : ${memberInfo?.name ?? ""}`, leftX + 18, y);

      y += 4;
      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`Né(e) le`, leftX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);

      doc.text(` : ${memberInfo?.dateBirth ?? ""}`, leftX + 18, y);

      y += 4;
      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`Téléphone`, leftX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(` : ${memberInfo?.tele ?? ""}`, leftX + 18, y);

      y += 4;
      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`Profession`, leftX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(` : ${memberInfo?.occupation ?? ""}`, leftX + 18, y);

      y = 38;
      const rightX = pageWidth / 2; // Start at half of page width for right-side info

      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`CIN`, rightX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(` : ${memberInfo?.cin ?? ""}`, rightX + 18, y);
      y += 5;

      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`Adresse`, rightX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(` : ${memberInfo?.adresse ?? ""}`, rightX + 18, y);

      y += 4;
      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`email`, rightX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(` : ${memberInfo?.email ?? ""}`, rightX + 18, y);

      y += 4;
      // doc.setFont("helvetica", "normal", "bold");
      // doc.setFontSize(8);
      // doc.text(`CIN`, rightX, y);
      // doc.setFont("helvetica", "normal", "normal");
      // doc.setFontSize(8);
      // doc.text(` : ${memberInfo.cin}`, rightX + 18, y);
    }
    // Helper function to add personal information
    function addSellerInfo() {
      doc.setTextColor(0, 0, 0); // White text
      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      y += lineHeight - 4;
      doc.text(`NOM DU COMMERCIAL`, leftX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(` : ${sellerInfo?.name ?? ""}`, leftX + 32, y);

      const rightX = pageWidth / 2; // Start at half of page width for right-side info
      doc.setFont("helvetica", "normal", "bold");
      doc.setFontSize(8);
      doc.text(`CE`, rightX, y);
      doc.setFont("helvetica", "normal", "normal");
      doc.setFontSize(8);
      doc.text(`: ${sellerInfo?.ce ?? ""}`, rightX + 5, y);

      // doc.text(`REABONNEMENT `, pageWidth - leftX, y, { align: "right" });
      y += lineHeight - 4;
    }

    // Helper function to add title and subtitle on the same line
    function addTitleAndSubtitle(article) {
      addPage();
      // Set title font
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(article?.titleColor ?? "#27359D"); // Set dynamic color
      doc.text(article?.title, leftX, y);
      // Calculate the width of the title to position the subtitle correctly
      const titleWidth = doc.getTextWidth(article?.title);
      // Set subtitle font and add it next to the title
      if (article?.subtitle) {
        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        doc.text(article?.subtitle ?? "", leftX + titleWidth + 5, y); // Add a small space after title
      }
      // Set subtitle font and add it next to the title
      if (article?.priceTitle) {
        doc.setFont("helvetica", "normal", "bold");
        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0); // Set dynamic color
        doc.text(article?.priceTitle ?? "", leftX + titleWidth + 3, y); // Add a small space after title
      }
      y += titleMarginBottom;
    }

    // Helper function to add article description
    function addDescription(article) {
      addPage();
      const font = article?.descriptioBold ? "bold" : "normal";
      const size = article?.descriptioBold ? 8 : 7;
      doc.setFontSize(size);
      doc.setFont("helvetica", "normal", font);
      if (article?.descriptionColor)
        doc.setTextColor(article?.descriptionColor ?? "");
      // Set dynamic color
      else doc.setTextColor(0, 0, 0); // Set dynamic color
      const lines = doc.splitTextToSize(
        article?.description ?? "",
        pageWidth - 20,
      ); // Wrap text
      lines.forEach((line) => {
        doc.text(line, leftX, y);
        y += descriptionLineHeight;
      });
      // Calculate the width of the title to position the subtitle correctly
      const titleWidth = doc.getTextWidth(article?.description ?? "");
      // Set subtitle font and add it next to the title
      if (article?.priceDesc) {
        doc.setFont("helvetica", "normal", "bold");
        doc.setFontSize(9);
        doc.text(article?.priceDesc ?? "", leftX + titleWidth + 3, y - 4); // Add a small space after title
      }
      console.log(parseInt(article?.spaceY));
      y += article?.spaceY
        ? parseInt(article?.spaceY)
        : descriptionMarginBottom;
    }

    // Helper function to add a bordered table with full-page width
    function addTable(headers, data) {
      addPage(); // Add a new page if needed
      doc.setFontSize(7);
      doc.setFont("helvetica", "normal");

      const tableY = y; // Initial Y position for the table
      const cellHeight = 5; // Row height
      const tableMarginBottom = 5; // Space after table

      const tableWidth = pageWidth - 20; // Full table width
      const columnWidths = headers.map((header, colIndex) => {
        const headerWidth = doc.getTextWidth(header ?? "") + 4; // Add padding
        const maxDataWidth = data.reduce((max, row) => {
          const cellWidth = doc.getTextWidth(row[colIndex] ?? "") + 4; // Add padding
          return Math.max(max, cellWidth);
        }, 0);
        return Math.max(headerWidth, maxDataWidth); // Choose the larger value
      });

      // Calculate the proportional width for each column
      const totalOriginalWidth = columnWidths.reduce(
        (sum, width) => sum + width,
        0,
      );
      const proportionalWidths = columnWidths.map(
        (width) => (width / totalOriginalWidth) * tableWidth,
      );

      // Draw headers with proportional widths
      let currentX = leftX;
      headers.forEach((header, index) => {
        const cellWidth = proportionalWidths[index];
        doc.rect(currentX, tableY, cellWidth, cellHeight); // Draw border for header cell
        doc.text(header ?? "", currentX + 2, tableY + cellHeight / 2 + 1); // Center text vertically
        currentX += cellWidth;
      });

      y += cellHeight;

      // Draw data rows with proportional widths
      data.forEach((row) => {
        currentX = leftX;
        row.forEach((cell, index) => {
          const cellWidth = proportionalWidths[index];
          doc.rect(currentX, y, cellWidth, cellHeight); // Draw border for each cell
          doc.text(cell ?? "", currentX + 2, y + cellHeight / 2 + 1); // Center text vertically
          currentX += cellWidth;
        });
        y += cellHeight;
      });

      y += tableMarginBottom; // Extra space after table
    }

    doc.setTextColor(0, 0, 0); // White text
    doc.setFont("helvetica", "normal", "bold");
    doc.setFontSize(12);
    doc.text(
      "N° Contrat : " + (memberInfo?.contractNumber ?? ""),
      pageWidth - leftX,
      y,
      { align: "right" },
    );
    y += 10;
    doc.setTextColor(0, 0, 0); // White text
    doc.setFont("helvetica", "normal", "bold");
    doc.setFontSize(14);
    doc.text("CONTRAT D’ABONNEMENT", pageWidth / 2, y, { align: "center" });

    // Add personal information to the PDF
    addMemberInfo();
    doc.setFont("helvetica", "normal", "normal");
    doc.setFontSize(8);
    y += 4;
    doc.text(`Ci après, dénom« L’adhérent » `, pageWidth - leftX, y, {
      align: "right",
    });
    addSellerInfo();

    // Loop through articles and render content dynamically
    firstArticles.forEach((article) => {
      if (article?.title) addTitleAndSubtitle(article);
      if (article?.description) addDescription(article);
      if (article?.table) addTable(article?.table.headers, article?.table.data);
    });

    y += 2.2;

    doc.setTextColor(0, 0, 0); // White text
    doc.setFont("helvetica", "normal", "bold");
    doc.setFontSize(8);
    doc.text("Signatures", leftX + 38, y, { align: "left" });

    doc.text("Pour le club", pageWidth - (leftX + 38), y, { align: "right" });

    // Set the desired width and calculate height to maintain the aspect ratio
    const signatureDesiredWidth = 26;
    const signatureAspectRatio = signatureNaturalWidth / signatureNaturalWidth; // Height / Width to maintain aspect ratio
    const signatureDesiredHeight = signatureDesiredWidth * signatureAspectRatio;
    console.log("signatureImageData");
    console.log(signatureImageData);
    if (signatureImageData) {
      doc.addImage(
        signatureImageData,
        "JPEG",
        pageWidth - (leftX + 60),
        y + 2,
        signatureDesiredWidth,
        signatureDesiredHeight - 10,
      );
    }
    y += 12;
    doc.addPage();
    y = 7;
    doc.setTextColor(0, 0, 0); // White text
    doc.setFont("helvetica", "normal", "bold");
    doc.setFontSize(11);
    doc.text(
      "CONDITION GENERALES DE VENTE ET REGLEMENT INTERIEUR",
      pageWidth / 2,
      y,
      { align: "center" },
    );
    y += 5;
    doc.setTextColor(0, 0, 0); // White text
    doc.setFont("helvetica", "normal", "bold");
    doc.setFontSize(10);
    const txt = "Les conditions générales et leur application :";
    doc.text(txt, leftX, y, { align: "left" });
    const textWidth = doc.getTextWidth(txt);
    doc.line(leftX, y + 1, leftX + textWidth, y + 1); // x1, y1, x2, y2
    y += 5;

    descriptionMarginBottom = 3;
    descriptionLineHeight = 3.5;
    titleMarginBottom = 3.2;
    // Loop through generalArticles and render content dynamically
    generalArticles.forEach((article) => {
      if (article?.title) addTitleAndSubtitle(article);

      if (article.description) addDescription(article);
    });
    // Save the PDF
    const filename =
      "Contrat de " +
      memberInfo?.name +
      " - " +
      memberInfo?.contractNumber +
      ".pdf";

    if (typeOfFile == "print") {
      doc.autoPrint();
      window.open(doc.output("bloburl"));
    } else if (typeOfFile == "pdf") {
      doc.save(filename);
    } else if (typeOfFile == "mail") {
      doc.save(filename);
    }
  };

  return {
    contratPDF,
  };
}
